<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'TutorLegalUpdatedAt',
})

defineProps<{
  value: string
}>()
</script>

<template>
  <div class="tutor-legal-updated">
    <AppText
      name="body1"
      color="slate-500"
      class="tutor-legal-updated__label"
    >
      Updated at
    </AppText>
    <AppText name="body1">
      {{ value || '—' }}
    </AppText>
  </div>
</template>

<style lang="scss" scoped src="./TutorLegalUpdatedAt.scss" />
